<template>
  <div class="bottom">
    <div class="bottom_data" v-if="data.length > 0">
      <h1>{{$t('战略合作单位')}}</h1>
      <a-spin :spinning="loading">
        <div class="companys">
          <div class="company" v-for="(item, index) in data" :key="index">
            <img :src="item.logo"/>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      programId: this.$route.query.programId,
      data: []
    }
  },
  mounted () {
    this.cooperationList()
  },
  methods: {
    cooperationList () {
      this.$api.projectCenter.cooperationList(this.programId).then(res => {
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(_ => {
        this.loading = false
      })
    }
  },
  watch: {
    '$route.query.programId': {
      handler (newValue, oldValue) {
        if (newValue != this.programId) {
          this.programId = this.$route.query.programId
          this.cooperationList()
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.bottom {
  padding: 50px 0px ;
  .bottom_data {
    width: 1200px;
    margin: auto;
    h1 {
      font-size: 34px;
      text-align: center;
      margin-bottom: 30px;
    }
    .companys {
      display: flex;
      justify-content: start;
      align-items: center;
      flex-wrap: wrap;
      .company {
        width: 20%;
        text-align: center;
        margin-bottom: 50px;
        img {
          max-height: 55px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/Bottom.vue